export enum NewUserOnboardingSteps {
  BEGIN_SETUP = 'BEGIN_SETUP',
  VIEW_SELECTION = 'VIEW_SELECTION',
  POP_SELECTION = 'POP_SELECTION',
  THEME_SELECTION = 'THEME_SELECTION',
}

export interface NewUserOnboardingStore {
  currentState: NewUserOnboardingSteps;
  currentStateIndex: number;
  stopCountdown: boolean;
  userSelectedData: {
    view: 'expanded' | 'compact';
    notificationDisplayTime: 'display_until_dismissed' | '4_sec_dismissal';
  };
  isNewUserOnboardingComplete: boolean;

  setIsNewUserOnboardingComplete: () => void;
  setCurrentStateIndex: (index: number) => void;
  setStopCountdown: () => void;
  setUserSelectedData: (data: {
    view: 'expanded' | 'compact';
    notificationDisplayTime: 'display_until_dismissed' | '4_sec_dismissal';
  }) => void;
}
